import { useCallback } from "react";
import type {
  IExtractedResultViewModel,
  IExtractedNodeViewModel,
} from "@models/index";

export const usePageNavigation = (
  extractedResult: IExtractedResultViewModel | undefined,
  totalPages: number,
  currentPage: number,
  setCurrentPage: (page: number) => void,
  setSelectedNode: (node: IExtractedNodeViewModel | undefined) => void,
) => {
  const selectPage = useCallback(
    (pageNumber: number) => {
      if (!extractedResult || pageNumber < 1 || pageNumber > totalPages) {
        return;
      }

      setCurrentPage(pageNumber);
    },
    [extractedResult, totalPages, setCurrentPage],
  );

  const selectNode = useCallback(
    (node: IExtractedNodeViewModel) => {
      setSelectedNode(node);
      const nodePage = node.data?.page;
      if (nodePage && nodePage !== currentPage) {
        selectPage(nodePage);
      }
    },
    [currentPage, selectPage, setSelectedNode],
  );

  return { selectPage, selectNode };
};
